import * as React from 'react';
import styled from 'styled-components';
import { colors } from '../constants';

interface IProps {
    className?: string;
}

export const BaseStar: React.FC<IProps> = ({ className }) => (
    <svg className={className} viewBox="0 0 512 512" xmlSpace="preserve">
        <g>
            <path
                d="M256,384c-70.7,0-128-57.3-128-128s57.3-128,128-128s128,57.3,128,128S326.7,384,256,384z M256,0
		c14.1,0,25.6,11.5,25.6,25.6v51.2c0,14.1-11.5,25.6-25.6,25.6c-14.1,0-25.6-11.5-25.6-25.6V25.6C230.4,11.5,241.9,0,256,0z
		 M256,409.6c14.1,0,25.6,11.5,25.6,25.6v51.2c0,14.1-11.5,25.6-25.6,25.6c-14.1,0-25.6-11.5-25.6-25.6v-51.2
		C230.4,421.1,241.9,409.6,256,409.6z M25.6,230.4h51.2c14.1,0,25.6,11.5,25.6,25.6c0,14.1-11.5,25.6-25.6,25.6H25.6
		C11.5,281.6,0,270.1,0,256C0,241.9,11.5,230.4,25.6,230.4z M435.2,230.4h51.2c14.1,0,25.6,11.5,25.6,25.6
		c0,14.1-11.5,25.6-25.6,25.6h-51.2c-14.1,0-25.6-11.5-25.6-25.6C409.6,241.9,421.1,230.4,435.2,230.4z M437,75
		c10,10,10,26.2,0,36.2l-36.2,36.2c-9.8,10.2-26,10.4-36.2,0.6c-10.2-9.8-10.5-26-0.6-36.2l0.6-0.6L400.8,75C410.8,65,427,65,437,75
		z M147.4,364.6c10,10,10,26.2,0,36.2L111.2,437c-9.8,10.2-26,10.5-36.2,0.6c-10.2-9.8-10.5-26-0.6-36.2l0.6-0.6l36.2-36.2
		C121.2,354.6,137.4,354.6,147.4,364.6z M111.2,75l36.2,36.2c9.8,10.2,9.6,26.4-0.6,36.2c-9.9,9.6-25.7,9.6-35.6,0L75,111.2
		C65.2,101,65.5,84.8,75.6,75C85.6,65.4,101.3,65.4,111.2,75L111.2,75z M400.8,364.6l36.2,36.2c9.8,10.2,9.5,26.4-0.6,36.2
		c-9.9,9.6-25.7,9.6-35.6,0l-36.2-36.2c-10.2-9.8-10.5-26-0.6-36.2c9.8-10.2,26-10.5,36.2-0.6L400.8,364.6z"
            />
        </g>
    </svg>
);

export const Star = styled(BaseStar)`
    height: 16px;
    width: 16px;
    fill: ${colors.greenDark};
`;
